import { Component, inject, OnInit } from '@angular/core';
import { CoreModule, IvvTitleComponent } from '@toevla-webapplications/core';
import { TranslateModule } from '@ngx-translate/core';
import { Offer } from '../../services/offers/offer.model';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, Observable, take } from 'rxjs';
import { FavoritesService } from '../../services/favorites/favorites.service';
import { AsyncPipe } from '@angular/common';
import { OfferCardComponent } from '../home/components/offer-card/offer-card.component';
import { HelpComponent } from '../../components/help/help.component';
import { OffersService } from '../../services/offers/offers.service';

@Component({
	selector: 'ivva-share',
	templateUrl: './share.component.html',
	styleUrls: ['./share.component.scss'],
	imports: [IvvTitleComponent, TranslateModule, AsyncPipe, OfferCardComponent, CoreModule, HelpComponent],
})
export class ShareComponent implements OnInit {
	offers$: Observable<Offer[]>;

	private readonly favoritesService = inject(FavoritesService);
	private readonly offersService = inject(OffersService);
	private readonly route = inject(ActivatedRoute);

	ngOnInit() {
		this.offers$ = this.favoritesService.shared$;

		this.route.queryParamMap.pipe(take(1)).subscribe((query) => {
			const ids = query.get('ids');

			if (ids) {
				this.getOffers(ids.split(','));
			}
		});
	}

	private getOffers(ids: string[]) {
		this.offers$.pipe(take(1)).subscribe((offers) => {
			const alreadyInShared = ids.every((id) => offers.find((offer) => offer.id === id));

			if (!alreadyInShared) {
				const requests = ids.map((id) => this.offersService.getOffer(id));
				forkJoin(requests).subscribe((offers) => this.favoritesService.setShared(offers));
			}
		});
	}
}
